import { jsx as _jsx } from "react/jsx-runtime";
import { useDatePicker } from '../DatePickerContext';
import { DatePickerContentBase } from './DatePickerContentBase';
export const DatePickerContent = ({ children, }) => {
    const { isMobile, disclosureProps: { isOpen, onClose }, initialFocusRef, styles, size, } = useDatePicker();
    return (_jsx(DatePickerContentBase, { size: size, isMobile: isMobile, headerStyles: styles.header, containerStyles: styles.container, isOpen: isOpen, onClose: onClose, initialFocusRef: initialFocusRef, children: children }));
};
